import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHeartFilledSidebar = (props) => /* @__PURE__ */ _jsx("svg", {
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m12.3693399 1.97721066c1.2774584-1.26595473 3.0104238-1.97721066 4.8174469-1.97721066s3.5399885.71125593 4.8174468 1.97721066c1.2777104 1.26501607 1.9957664 2.98156998 1.9957664 4.77148027s-.718056 3.50646417-1.9959403 4.77165257l-9.2633682 9.1756425c-.4092274.405352-1.0727161.405352-1.4819435 0l-9.26336828-9.1756425c-2.66050632-2.63531098-2.66050629-6.90799416.00000007-9.54330507s6.97403943-2.63531094 9.63454581-.00000006l.3697941.3662921z",
		fill: "#2b2b2b",
		transform: "translate(0 2)"
	})
});
export default SvgHeartFilledSidebar;
